// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1zLKs","row":"ProcedureTreatmentSummary_row__2Pnu2"};